import styled from 'styled-components';

import {
  Avatar,
  Button,
} from 'web-components';
import { Flex } from 'web-styled';

export const StyledAvatar = styled(Avatar).attrs({
  width: '95px',
  height: '95px',
  bgColor: 'transparent',
  placeholderSize: 48,
})`
  border: 3px solid #fff;
  border-radius: 50%;
  margin-bottom: 5px;
`;

export const ClientSummary = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 8px;
  padding: 13px;

  .stat-item {
    padding: 15px 10px 40px 10px;
    border-radius: 18px;
    text-align: center;
    line-height: 100%;
    background: #F7F7F7;

    .stat-unit,
    .stat-label {
      color: #A7A7A7;
      font-weight: 400;
      font-size: 16px;
    }

    .stat-value {
      color: #5F5F5F;
      font-weight: 700;
      font-size: 25px;
      margin-top: 27px;
      margin-bottom: 10px;
      min-height: 16px;
    }
  }
`;

export const Card = styled.div`
  border: 1px solid #F0F0F0;
  box-shadow: 0px 3px 6px 0px #00000029;

  background: #fff;
  border-radius: 5px;

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 10px;
    border-bottom: 1px solid #F0F0F0;

    h5 {
      color: #717171;
      font-weight: 700;
      font-size: 18px;
      line-height: 100%;
      margin: 0;
      padding: 5px 0;
    }
  }

  .empty-note {
    height: 94px;
  }
`;

export const LinkButton = styled(Button).attrs({
  spacing: 'middle',
})`
  color: ${props => props.theme.colors.primary};
  border-color: #ffffff;
  background: #ffffff;

  &:hover {
    border-color: #ffffff;
    background: #ffffff;
  }
`;

export const CardsBox = styled(Flex).attrs({
  spacing: 25,
  align: 'stretch',
})`

  & > div {
    width: 420px;

    @media (min-width: 1800px) {
      width: 470px;
    }
  }
`;
